import React from "react";
import { useState } from "react";
import {
  validateCNPJ,
  validateCPF,
  validateEmail,
  validatePhone,
} from "../../../../../utils";
import { toast } from "react-toastify";

const useChange = (initialState) => {
  const [state, setState] = useState(initialState);

  const handleChange = (e) => {
    let { name, value } = e.target;
    setState({ ...state, [name]: value });
  };

  // no risk no fun
  handleChange.forceUpdate = (newState) => setState(newState);

  return [state, handleChange];
};

/**
 * Valida o estado e retorna { data, errors }.
 * `errors` é um Set com os nomes dos campos inválidos.
 * `data` é null quando há erros.
 */
const useGetData = (state) => {
  const errors = new Set();

  const check = (name, validator) => {
    if (!validator(state[name])) errors.add(name);
  };

  let data = null;

  if (state.type == 1 || state.type == 3) {
    check("cpf", validateCPF);
    check("name", (v) => !!v);
    const rawPhone = (state.phone_number || "").replace(/\D+/g, "");
    if (!rawPhone || !validatePhone(rawPhone)) {
      errors.add("phone_number");
    }
    check("email", (v) => !v || validateEmail(v));
    if (state.type == 3) check("state_registry", (v) => !!v);

    if (errors.size === 0) {
      data = {
        name: state.name,
        email: state.email || "",
        phone_number: (state.phone_number || "").replace(/\D+/g, ""),
        individual: {
          cpf: (state.cpf || "").replace(/\D+/g, ""),
          ...(state.type == 3 ? {
            state_registry: state.state_registry === "ISENTO"
              ? "ISENTO"
              : (state.state_registry || "").replace(/\D+/g, "")
          } : {})
        },
      };
    }
  } else if (state.type == 2) {
    if (!validateCNPJ(state.cnpj)) {
      toast.error("CNPJ inválido.", {
        toastId: "register-client-cnpj-invalid",
        position: "top-center",
      });
      errors.add("cnpj");
    } else {
      check("cnpj", validateCNPJ);
      check("company_name", (v) => !!v);
      check("company_email", (v) => !v || validateEmail(v));
      const rawCompanyPhone = (state.company_phone_number || "").replace(/\D+/g, "");
      if (!rawCompanyPhone || !validatePhone(rawCompanyPhone)) {
        errors.add("company_phone_number");
      }
      check("company_state_registry", (v) => !!v);
      check("fancy_name", (v) => !!v);

      if (errors.size === 0) {
        data = {
          name: state.company_name,
          email: state.company_email || "",
          phone_number: (state.company_phone_number || "").replace(/\D+/g, ""),
          company: {
            cnpj: state.cnpj ? state.cnpj.replace(/\D+/g, "") : "",
            fancy_name: state.fancy_name,
            state_registry:
              state.company_state_registry === "ISENTO"
                ? "ISENTO"
                : (state.company_state_registry || "").replace(/\D+/g, ""),
            municipal_registry: "",
          },
        };
      }
    }
  }

  return { data, errors };
};

export { useChange, useGetData };



// WEBPACK FOOTER //
// ./src/views/AppViews/Clients/Client/hooks/index.js